// Simple client for the external solver API
// Env vars (CRA-compatible):
// - REACT_APP_SOLVER_HOST (fallback: HOST)
// - REACT_APP_API_KEY (fallback: API_KEY)

const API_KEY = process.env.REACT_APP_API_KEY || process.env.API_KEY || '';
const IS_DEV = process.env.NODE_ENV === 'development';
// In dev, prefer CRA proxy at '/solver'; in prod, prefer Netlify function proxy
const BASE = IS_DEV ? '/solver' : '/.netlify/functions/solver';

function defaultParams() {
  const maxTime = Number(process.env.REACT_APP_SOLVER_MAX_TIME_S || 15);
  const workers = Number(process.env.REACT_APP_SOLVER_WORKERS || 4);
  const seed = Number(process.env.REACT_APP_SOLVER_RANDOM_SEED || 42);
  return { max_time_s: maxTime, num_search_workers: workers, random_seed: seed };
}

async function http(method, path, body) {
  if (!BASE) throw new Error('Solver base not configured');
  const url = `${BASE}${path}`;
  const res = await fetch(url, {
    method,
    headers: {
      'Content-Type': 'application/json',
      // In dev direct proxy, some setups still expect an API key header.
      // Netlify function attaches the server-side key in production.
      ...(IS_DEV && API_KEY ? { 'X-API-Key': API_KEY } : {}),
    },
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) {
    const txt = await res.text().catch(() => '');
    throw new Error(`Solver API ${method} ${path} failed: ${res.status} ${txt}`);
  }
  return res.json();
}

export const SolverApi = {
  async submitJob(payload) {
    // Accept either a full envelope { model, params } or a bare model object
    const isEnvelope = payload && (Object.prototype.hasOwnProperty.call(payload, 'model') || Object.prototype.hasOwnProperty.call(payload, 'params'));
    const body = isEnvelope ? payload : { model: payload, params: defaultParams() };
    // eslint-disable-next-line no-console
    console.log('[Solver Submit Body]', body);
    // Expects { job_id: string } in response
    return http('POST', '/jobs', body);
  },
  async getJob(jobId) {
    return http('GET', `/jobs/${encodeURIComponent(jobId)}`);
  },
  async getJobStatus(jobId) {
    const job = await this.getJob(jobId);
    // Try common fields
    return job.status || job.state || job.job_status || null;
  },
  async getJobResult(jobId) {
    return http('GET', `/jobs/${encodeURIComponent(jobId)}/result`);
  },
};
